import Button from "devextreme-react/button";
import { Template } from "devextreme-react/core/template";
import Toolbar, { Item } from "devextreme-react/toolbar";
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Image, Popup } from "semantic-ui-react";
import appInfo from "../../app-info";
import { useAuth } from "../../contexts/auth";
import { useTranslate } from "../../contexts/translate";
import { coSoActionTypes } from '../../state/reducers/coSoReducer';
import ComboboxCoSo from "../editor/cmb_coso";
import UserPanel from "../user-panel/user-panel";
import "./header.scss";

export default ({ menuToggleEnabled, title, toggleMenu, menuStatus }) => {
  const { user, signOut } = useAuth();
  const { translate } = useTranslate();
  const { dm_coso_id } = useSelector(x => x.coSo);
  const dispatch = useDispatch();

  let history = useHistory();
  const handleLanguageChange = (e, { name, value }) => {
    localStorage.language = value;
    history.go(0);
  };
  const renderBrandName = () => {
    return (
      <a>
        <div className="toolbar-label header-title">
          {translate("QUẢN LÝ BÁN ĐỒNG PHỤC, HỌC PHẨM")}
        </div>
      </a>
    );
  };
  const renderLogo = () => {
    return (
      <img
          alt='logo'
          style={{ height: "40px", borderRadius: '5px', marginLeft:'10px', cursor:'pointer' }}
          src="https://portal.truenorth.edu.vn/images/logo-white.svg"
          onClick={handleClick}
      />
  );
  }
  const handleClick = () => {
    window.location.href = 'https://portal.truenorth.edu.vn'

};
  const PopupContent = (apps) => {
    return (
      <div className="row width-400">
        {apps.map((x) => {
          return (
            <div className="col-md-4" key={x.id}>
              <div
                className={
                  "system-other padding-1rem" +
                  (!x.is_accessed ? " system-other-disabled" : "")
                }
              >
                <a
                  onClick={() => {
                    if (x.is_accessed) {
                      if (x.url) {
                        if (x.url.split("/")[0].includes("http")) {
                          window.location.href = x.url;
                        }
                      }
                    }
                  }}
                >
                  <Image
                    src={"/images/" + x.icon}
                    className="system-other-img"
                  />
                  <p className="system-other-name">{x.name}</p>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <header className={"header-component"}>
      <Toolbar className={"header-toolbar"}>
        <Item location={"before"} render={renderLogo}></Item>
        <Item
          visible={true}
          location={"before"}
          widget={"dxButton"}
          cssClass={"menu-button"}
        >
          <div
            style={{
              display: "flex",
              position: "relative",
              left: "20px",
            }}
          >
            <div
              className="header-nav-btn"
              onClick={() => {
                history.goBack();
              }}
            >
              <i className={"fas fa-chevron-left"}></i>
            </div>
            <div
              className="header-nav-btn"
              onClick={() => {
                history.goForward();
              }}
            >
              <i className={"fas fa-chevron-right"}></i>
            </div>
          </div>
        </Item>
        {/* <Item
          visible={menuToggleEnabled}
          location={"before"}
          widget={"dxButton"}
          cssClass={"menu-button"}
        >
          <Button
            className="expand-menu"
            stylingMode="text"
            onClick={toggleMenu}
          >
            <i
              className={
                menuStatus === 1
                  ? "fas fa-chevron-right"
                  : "fas fa-chevron-left"
              }
            ></i>
          </Button>
        </Item> */}
        <Item
          location={"center"}
          cssClass={"header-title"}
          text={title}
          visible={!!title}
          render={renderBrandName}
        />
        <Item
          location="after"
          cssClass={"cbo-coso"}
          render={() => (
            <ComboboxCoSo
              value={1}              
              // onValueChanged={(value) => {
              //   setCoSoId(value);
              // }}
              onValueChanged={(value) => {
                dispatch({ type: coSoActionTypes.CHANGE_SELECTED_ID, payload: value })
              }}
            />
          )}
        />
        {/* <Item
          location={"after"}
          text={title}
          visible={!!title}
          render={() => {
            return (
              <a
                href="https://sites.google.com/view/hns-retail-userguide/home"
                target={"_blank"}
                style={{
                  color: "#fff",
                  fontSize: "13px",
                }}
              >
                <i
                  class="fas fa-file"
                  style={{
                    marginRight: 10,
                  }}
                ></i>
                Hướng dẫn sử dụng
              </a>
            );
          }}
        /> */}
        <Item
          visible={true}
          location={"after"}
          widget={"dxButton"}
          cssClass={"menu-button"}
        >
          <Popup
            content={() => {
              return PopupContent(user.sub_systems);
            }}
            on="click"
            popper={{ id: "popper-container", style: { zIndex: 2000 } }}
            trigger={<Button icon="menu" stylingMode="text" />}
          />
        </Item>

        <Item
          location={"after"}
          locateInMenu={"auto"}
          menuItemTemplate={"userPanelTemplate"}
        >
          <Button
            className={"user-button authorization"}
            width={210}
            height={"100%"}
            stylingMode={"text"}
          >
            <UserPanel menuMode={"context"} />
          </Button>
        </Item>
        {/* <Item
          location={'after'}
          locateInMenu={'auto'}
          render={() => {
            return (
              <React.Fragment>
                <div className='select-box-language' style={{width:150}}>
                  <Dropdown
                    placeholder='Ngôn ngữ/ Language'
                    fluid
                    selection
                    onChange={handleLanguageChange}
                    defaultValue={localStorage.language != null ? localStorage.language : "vn"}
                    options={[
                      { key: "vn", value: "vn", text: "Việt Nam", flag: "vn" },
                      { key: "us", value: "us", text: "English", flag: "us" }
                    ]}
                  />
                </div>
              </React.Fragment>
            );
          }}
        /> */}
        <Template name={"userPanelTemplate"}>
          <UserPanel menuMode={"list"} />
        </Template>
      </Toolbar>
    </header>
  );
};
